import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../Redux/Actions/SnackBar";

const SnackBar = () => {
  const dispatch = useDispatch();
  const open = useSelector((snackBar) => snackBar.snackBar.open);
  const message = useSelector((snackBar) => snackBar.snackBar.message);
  const variant = useSelector((snackBar) => snackBar.snackBar.variant);
  const handleClose = () => {
    dispatch(setSnackbar({ open: false, message: "", variant: "success" }));
  };

  return (
    <Snackbar
      open={open}
      className="!top-16 !capitalize"
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      TransitionComponent={Slide}
      onClose={handleClose}
      autoHideDuration={5000}
      message={message}
      children={
        <Alert variant="filled" severity={variant}>
          {message}
        </Alert>
      }
    />
  );
};

export default SnackBar;
